<template>
  <div class="shipment-tab" v-loading="loading">
    <el-row :gutter="20">
      <!-- LC 정보 -->
      <el-col :span="12">
        <h4>
          LC 현황
          <el-button v-if="canEdit" size="small" type="primary" style="float: right">
            LC 연결
          </el-button>
        </h4>
        <el-table :data="lcs || []" stripe size="small">
          <el-table-column prop="lc_number" label="LC번호" width="130" />
          <el-table-column label="상태" width="80">
            <template #default="{ row }">
              <el-tag :type="getLCStatusType(row.status)" size="small">
                {{ row.status_display }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="금액" align="right">
            <template #default="{ row }">
              {{ row.currency }} {{ formatNumber(row.amount) }}
            </template>
          </el-table-column>
          <el-table-column prop="expiry_date" label="유효기일" width="100" />
        </el-table>
        <el-empty v-if="lcs.length === 0" description="연결된 LC가 없습니다" :image-size="60" />
      </el-col>

      <!-- 선적 정보 -->
      <el-col :span="12">
        <h4>
          선적 스케줄
          <el-button v-if="canEdit" size="small" type="primary" style="float: right">
            선적 추가
          </el-button>
        </h4>
        <el-table :data="shipments || []" stripe size="small">
          <el-table-column prop="shipment_number" label="선적번호" width="120" />
          <el-table-column label="상태" width="80">
            <template #default="{ row }">
              <el-tag :type="getShipmentStatusType(row.status)" size="small">
                {{ row.status_display }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="수량" width="80" align="right" />
          <el-table-column prop="etd" label="ETD" width="100" />
          <el-table-column prop="eta" label="ETA" width="100" />
        </el-table>
        <el-empty v-if="shipments.length === 0" description="등록된 선적이 없습니다" :image-size="60" />
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axiosInstance from '@/api/axios'

const props = defineProps({
  mainRequestId: {
    type: [String, Number],
    required: true
  },
  canEdit: {
    type: Boolean,
    default: false
  }
})

const loading = ref(false)
const lcs = ref([])
const shipments = ref([])

const formatNumber = (num) => {
  return parseFloat(num || 0).toLocaleString()
}

const getLCStatusType = (status) => {
  const types = {
    'DRAFT': 'info',
    'REQUESTED': 'warning',
    'ISSUED': '',
    'SHIPPED': 'success',
    'SETTLED': 'info'
  }
  return types[status] || 'info'
}

const getShipmentStatusType = (status) => {
  const types = {
    'PLANNED': 'info',
    'BOOKED': 'warning',
    'LOADED': '',
    'IN_TRANSIT': '',
    'ARRIVED': 'success',
    'DELIVERED': 'success'
  }
  return types[status] || 'info'
}

const fetchData = async () => {
  loading.value = true
  try {
    const [lcRes, shipmentRes] = await Promise.all([
      axiosInstance.get('lcs/', { params: { main_request: props.mainRequestId } }),
      axiosInstance.get('shipments/', { params: { main_request: props.mainRequestId } })
    ])

    lcs.value = lcRes.data.results || lcRes.data
    shipments.value = shipmentRes.data.results || shipmentRes.data
  } catch (error) {
    console.error('Failed to fetch shipment data:', error)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchData()
})
</script>

<style scoped>
.shipment-tab {
  padding: 20px;
}

h4 {
  margin-bottom: 15px;
  color: #303133;
}
</style>
